import { createFileRoute } from '@tanstack/react-router'

import { InvoiceDetailPage } from '../../../../components/pages/backoffice/platform/invoice-detail-page.tsx'
import { PermissionChecker } from '../../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/invoicing/$invoiceId')({
  component: () => (
    <PermissionChecker requiredPermissions={['invoice.read']}>
      <InvoiceDetailPage />
    </PermissionChecker>
  ),
})
